import type { FC, ReactNode } from 'react';
import { createContext } from 'react';
import type { WidgetSettings } from '../../typings/configuration.types';

export const Context = createContext<WidgetSettings | null>(null);

interface Props {
    children: ReactNode;
    configuration: WidgetSettings;
}

export const Provider: FC<Props> = ({ children, configuration }) => {
    return <Context.Provider value={configuration}>{children}</Context.Provider>;
};
